function positionTopLeft(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left + window.pageXOffset,
    top: targetRect.top - popoverRect.height + window.pageYOffset
  };
}
function positionTopCenter(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left + targetRect.width / 2 - popoverRect.width / 2 + window.pageXOffset,
    top: targetRect.top - popoverRect.height + window.pageYOffset
  };
}
function positionTopRight(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.right - popoverRect.width + window.pageXOffset,
    top: targetRect.top - popoverRect.height + window.pageYOffset
  };
}
function positionTopFullWidth(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left + window.pageXOffset,
    top: targetRect.top - popoverRect.height + window.pageYOffset,
    width: targetRect.width
  };
}
function positionBottomLeft(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left + window.pageXOffset,
    top: targetRect.top + targetRect.height + window.pageYOffset
  };
}
function positionBottomCenter(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left + targetRect.width / 2 - popoverRect.width / 2 + window.pageXOffset,
    top: targetRect.top + targetRect.height + window.pageYOffset
  };
}
function positionBottomRight(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.right - popoverRect.width + window.pageXOffset,
    top: targetRect.top + targetRect.height + window.pageYOffset
  };
}
function positionBottomFullWidth(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left + window.pageXOffset,
    top: targetRect.top + targetRect.height + window.pageYOffset,
    width: targetRect.width
  };
}
function positionLeftTop(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left - popoverRect.width + window.pageXOffset,
    top: targetRect.top + window.pageYOffset
  };
}
function positionLeftCenter(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left - popoverRect.width + window.pageXOffset,
    top: targetRect.top + targetRect.height / 2 - popoverRect.height / 2 + window.pageYOffset
  };
}
function positionLeftBottom(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left - popoverRect.width + window.pageXOffset,
    top: targetRect.top + targetRect.height - popoverRect.height + window.pageYOffset
  };
}
function positionLeftFullHeight(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left - popoverRect.width + window.pageXOffset,
    top: targetRect.top + window.pageYOffset,
    height: targetRect.height
  };
}
function positionRightTop(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left + targetRect.width + window.pageXOffset,
    top: targetRect.top + window.pageYOffset
  };
}
function positionRightCenter(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left + targetRect.width + window.pageXOffset,
    top: targetRect.top + targetRect.height / 2 - popoverRect.height / 2 + window.pageYOffset
  };
}
function positionRightBottom(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left + targetRect.width + window.pageXOffset,
    top: targetRect.top + targetRect.height - popoverRect.height + window.pageYOffset
  };
}
function positionRightFullHeight(targetRect, popoverRect) {
  if (!targetRect || !popoverRect) {
    return {};
  }
  return {
    left: targetRect.left + targetRect.width + window.pageXOffset,
    top: targetRect.top + window.pageYOffset,
    height: targetRect.height
  };
}
export {
  positionBottomCenter,
  positionBottomFullWidth,
  positionBottomLeft,
  positionBottomRight,
  positionLeftBottom,
  positionLeftCenter,
  positionLeftFullHeight,
  positionLeftTop,
  positionRightBottom,
  positionRightCenter,
  positionRightFullHeight,
  positionRightTop,
  positionTopCenter,
  positionTopFullWidth,
  positionTopLeft,
  positionTopRight
};
